import React from 'react';

const PrintShippingNotice = () => (
  <aside className="print-shipping-notice" aria-label="Print shipping information">
    <strong>Prints ship separately from books.</strong>
    <p>We cover the second shipment for U.S. orders, but can’t afford to for international orders at the moment. International shipping can be quite expensive, and we’re working on cheaper options.</p>
  </aside>
);

export default PrintShippingNotice;
